/* unplugin-vue-components disabled */import { render } from "./LogicalTransformer2D.vue?vue&type=template&id=2b74e8d9&scoped=true"
import script from "./LogicalTransformer2D.vue?vue&type=script&lang=js"
export * from "./LogicalTransformer2D.vue?vue&type=script&lang=js"

import "./LogicalTransformer2D.vue?vue&type=style&index=0&id=2b74e8d9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b74e8d9"]])

export default __exports__